// OrderBookFX.js
import React from "react";
import OrderBook from "../components/OrderBook";

const OrderBookFX = () => {
  return (
    <div style={{ display: "flex", gap: 40, padding: 20 }}>
      {/* Kraken */}
      <OrderBook
        symbol="USDC/EUR"
        depth={25}
        wsUrl="/api/crypto-node/kraken_depth?symbol=USDC/EUR&depth=25"
        format="kraken"
      />

      {/* Binance */}
      <OrderBook
        symbol="USDC/USDT"
        depth={25}
        wsUrl="/api/crypto-node/binance_depth?symbol=USDCUSDT&depth=25"
        format="binance"
      />
    </div>
  );
};

export default OrderBookFX;

